import { createSelector } from 'reselect'
import StoreState from 'store/state'

const uiSelector = (state: StoreState) => state.ui
export const calloutsSelector = createSelector(uiSelector, ui => ui.callouts)
export const activeCalloutSelector = createSelector(uiSelector, ui => ui.activeCallout)
export const trialPopupForceOpenWithHandleSelector = createSelector(uiSelector, ui => ui.trialPopupForceOpen)
export const isTrialWidgetHiddenSelector = createSelector(uiSelector, ui => ui.trainingWidgetHidden)
export const composerContentDialogSelector = createSelector(uiSelector, ui => ui.composerContentDialog)
export const videoCoverDialogSelector = createSelector(uiSelector, ui => ui.videoCoverDialog)
